import { render } from "./ConfigListaArquivosView.vue?vue&type=template&id=43a03870"
import script from "./ConfigListaArquivosView.vue?vue&type=script&lang=js"
export * from "./ConfigListaArquivosView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\SGCAD26\\ConfiguradorSistema\\FrontBackEndVue\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__